import { createAppSelector, selectCurrentSectionId } from "./base";

import type { UserType } from "components/server-types";
import { RootState } from "store";

export const selectAssessmentInfoForPage = createAppSelector(
  [(state) => state.computed, (state, pageId: string) => pageId],
  (computed, pageId) => computed.pageAssessmentStatuses[pageId],
);

export const selectAllAssessmentInfo = (state: RootState) => state.computed.pageAssessmentStatuses;

export const selectLateSubmissionCounts = createAppSelector(
  [selectAllAssessmentInfo, selectCurrentSectionId, (state: RootState) => state.pages],
  (allAssessmentInfo, sectionId, pages) => {
    let totalLateCount = 0;
    let newLateCount = 0;

    for (const pageId of Object.keys(allAssessmentInfo)) {
      const page = pages[pageId];
      if (page && !page.assessing_marked_complete_at && page.section_id === sectionId) {
        totalLateCount += allAssessmentInfo[pageId].unassessed_late_submissions_count;
        newLateCount += allAssessmentInfo[pageId].unseen_late_submissions_count;
      }
    }

    return { totalLateCount, newLateCount };
  },
);

export const selectInviteStatusForUser = createAppSelector(
  [(state) => state.computed, (state, user: UserType) => user],
  (computed, user) => computed.userInviteStatuses[user.id],
);

export const selectUserInviteStatuses = (state: RootState) => state.computed.userInviteStatuses;
